module.exports = __webpack_public_path__ + "img/app-store.2ab15d1c.png";